function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 9.56763V31.8057C1 31.8057 1.23384 53.5775 26.965 61.0294C26.965 61.0294 49.7709 56.8379 52.4615 32.504V9.56763L26.7304 2L1 9.56763Z",
  fill: "#1E88E5",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36 24.5H34.5V41.75C34.5 42.0625 34.4414 42.3555 34.3242 42.6289C34.207 42.9023 34.0469 43.1406 33.8438 43.3438C33.6406 43.5469 33.4023 43.707 33.1289 43.8242C32.8555 43.9414 32.5625 44 32.25 44H20.25C19.9375 44 19.6445 43.9414 19.3711 43.8242C19.0977 43.707 18.8594 43.5469 18.6562 43.3438C18.4531 43.1406 18.293 42.9023 18.1758 42.6289C18.0586 42.3555 18 42.0625 18 41.75V24.5H16.5V23H22.5V21.5C22.5 21.2891 22.5391 21.0938 22.6172 20.9141C22.6953 20.7344 22.8008 20.5781 22.9336 20.4453C23.0742 20.3047 23.2344 20.1953 23.4141 20.1172C23.5938 20.0391 23.7891 20 24 20H28.5C28.7109 20 28.9062 20.0391 29.0859 20.1172C29.2656 20.1953 29.4219 20.3047 29.5547 20.4453C29.6953 20.5781 29.8047 20.7344 29.8828 20.9141C29.9609 21.0938 30 21.2891 30 21.5V23H36V24.5ZM24 23H28.5V21.5H24V23ZM33 24.5H19.5V41.75C19.5 41.9531 19.5742 42.1289 19.7227 42.2773C19.8711 42.4258 20.0469 42.5 20.25 42.5H32.25C32.4531 42.5 32.6289 42.4258 32.7773 42.2773C32.9258 42.1289 33 41.9531 33 41.75V24.5ZM24 39.5H22.5V27.5H24V39.5ZM27 39.5H25.5V27.5H27V39.5ZM30 39.5H28.5V27.5H30V39.5Z",
  fill: "white"
});

var SvgErise = function SvgErise(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 63,
    viewBox: "0 0 54 63",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErise, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Erise.f4fe541f.svg";
export { ForwardRef as ReactComponent };